<template>

  <!-- Menu Desktop Moderno -->
  <div class="deznav modern-sidebar" data-layout="vertical">
    <div class="sidebar-gradient"></div>
    <div class="deznav-scroll modern-scroll">
      <ul id="menu" class="modern-menu">
        <li class="nav-label">
          <span class="nav-label-text">Menu Principal</span>
        </li>

        <!-- Página Inicial -->
        <li :class="{ 'active-menu': $route.path == '/admin' }">
          <router-link class="menu-item" to="/admin">
            <div class="menu-icon-wrapper">
              <font-awesome-icon :icon="['fa', 'home']" class="menu-icon" />
            </div>
            <span class="nav-text">Página Inicial</span>
            <div class="menu-indicator"></div>
          </router-link>
        </li>

        <!-- Contratos -->
        <li v-if="$store.getters.user.access.indexOf(2) > -1"
          :class="{ 'active-menu': $route.path == '/admin/contract-list' }">
          <router-link class="menu-item" to="/admin/contract-list">
            <div class="menu-icon-wrapper">
              <font-awesome-icon :icon="['fa', 'file-contract']" class="menu-icon" />
            </div>
            <span class="nav-text">Contratos</span>
            <div class="menu-indicator"></div>
          </router-link>
        </li>

        <!-- Financeiro -->
        <li v-if="$store.getters.user.access.indexOf(3) > -1" :class="{
          'active-menu': $route.path == '/admin/invoice-list' || $route.path == '/admin/financial-dash'
        }">
          <a class="menu-item submenu-trigger" @click="openMenu">
            <div class="menu-icon-wrapper">
              <font-awesome-icon :icon="['fa', 'coins']" class="menu-icon" />
            </div>
            <span class="nav-text">Financeiro</span>
            <font-awesome-icon :icon="!menuFinanceiroOpened ? ['fa', 'chevron-right'] : ['fa', 'chevron-down']"
              class="submenu-arrow" />
          </a>
          <ul id="menuFinanceiro" class="modern-submenu" :class="{ 'submenu-open': menuFinanceiroOpened }">
            <li v-if="$store.getters.user.access.indexOf(4) > -1">
              <router-link to="/admin/invoice-list" class="submenu-item">
                <span class="submenu-dot"></span>
                <span>Consulta de Títulos</span>
              </router-link>
            </li>
            <li v-if="$store.getters.user.access.indexOf(5) > -1">
              <router-link to="/admin/financial-dash" class="submenu-item">
                <span class="submenu-dot"></span>
                <span>Dashboard Financeiro</span>
              </router-link>
            </li>
          </ul>
        </li>

        <!-- Pedidos -->
        <li v-if="$store.getters.user.access.indexOf(9) > -1" :class="{
          'active-menu': $route.path == '/admin/order-unbilled-list' ||
            $route.path == '/admin/order-list' || $route.path == '/admin/order-new' ||
            $route.path == '/admin/order-finished-list' || $route.path == '/admin/order-draft' ||
            $route.path == '/admin/order-list-ni'
        }">
          <a class="menu-item submenu-trigger" @click="openMenuOrder">
            <div class="menu-icon-wrapper">
              <font-awesome-icon :icon="['fa', 'shopping-cart']" class="menu-icon" />
            </div>
            <span class="nav-text">Pedidos</span>
            <font-awesome-icon :icon="!menuPedidosOpened ? ['fa', 'chevron-right'] : ['fa', 'chevron-down']"
              class="submenu-arrow" />
          </a>
          <ul id="menuPedidos" class="modern-submenu" :class="{ 'submenu-open': menuPedidosOpened }">
            <li v-if="$store.getters.user.access.indexOf(10) > -1">
              <router-link to="/admin/order-new" class="submenu-item">
                <span class="submenu-dot"></span>
                <span>Novo Pedido</span>
              </router-link>
            </li>
            <li v-if="$store.getters.user.access.indexOf(11) > -1">
              <router-link to="/admin/order-unbilled-list" class="submenu-item">
                <span class="submenu-dot"></span>
                <span>Pedidos a Faturar</span>
              </router-link>
            </li>
            <li v-if="$store.getters.user.access.indexOf(12) > -1">
              <router-link to="/admin/order-list" class="submenu-item">
                <span class="submenu-dot"></span>
                <span>Pedidos em Rota</span>
              </router-link>
            </li>
            <li v-if="$store.getters.user.access.indexOf(13) > -1">
              <router-link to="/admin/order-finished-list" class="submenu-item">
                <span class="submenu-dot"></span>
                <span>Pedidos Entregues</span>
              </router-link>
            </li>
            <li v-if="$store.getters.user.access.indexOf(14) > -1">
              <router-link to="/admin/order-list-ni" class="submenu-item">
                <span class="submenu-dot"></span>
                <span>Pedidos Realizados</span>
              </router-link>
            </li>
            <li v-if="$store.getters.user.access.indexOf(15) > -1">
              <router-link to="/admin/order-draft" class="submenu-item">
                <span class="submenu-dot"></span>
                <span>Pedidos em Rascunho</span>
              </router-link>
            </li>
          </ul>
        </li>

        <!-- Embalagens -->
        <li v-if="dotEnv.isAmbientaly && $store.getters.user.access.indexOf(19) > -1" :class="{
          'active-menu': $route.path == '/admin/packaging-list'
        }">
          <router-link class="menu-item" to="/admin/packaging-list">
            <div class="menu-icon-wrapper">
              <font-awesome-icon :icon="['fa', 'box-open']" class="menu-icon" />
            </div>
            <span class="nav-text">Embalagens</span>
            <div class="menu-indicator"></div>
          </router-link>
        </li>

        <!-- Documentos -->
        <li v-if="$store.getters.user.access.indexOf(20) > -1" :class="{
          'active-menu': $route.path == '/admin/fds-list' || $route.path == '/admin/fde-list' ||
            $route.path == '/admin/winner-docs'
        }">
          <a class="menu-item submenu-trigger" @click="openMenuDocuments">
            <div class="menu-icon-wrapper">
              <font-awesome-icon :icon="['fa', 'file-alt']" class="menu-icon" />
            </div>
            <span class="nav-text">Documentos</span>
            <font-awesome-icon :icon="!menuDocumentsOpened ? ['fa', 'chevron-right'] : ['fa', 'chevron-down']"
              class="submenu-arrow" />
          </a>
          <ul id="menuDocuments" class="modern-submenu" :class="{ 'submenu-open': menuDocumentsOpened }">
            <li v-if="$store.getters.user.access.indexOf(21) > -1">
              <router-link to="/admin/fds-list" class="submenu-item">
                <span class="submenu-dot"></span>
                <span>FDS</span>
              </router-link>
            </li>
            <li v-if="$store.getters.user.access.indexOf(22) > -1">
              <router-link to="/admin/fde-list" class="submenu-item">
                <span class="submenu-dot"></span>
                <span>Ficha de Emergência</span>
              </router-link>
            </li>
            <li v-if="$store.getters.user.access.indexOf(29) > -1">
              <router-link to="/admin/winner-docs" class="submenu-item">
                <span class="submenu-dot"></span>
                <span>Certidões</span>
              </router-link>
            </li>
          </ul>
        </li>

        <!-- Telemetria -->
        <li v-if="$store.getters.user.access.indexOf(40) > -1" :class="{
          'active-menu': $route.path == '/admin/telemetry'
        }" class="menu-item-novo">
          <router-link class="menu-item" to="/admin/telemetry">
            <div class="menu-icon-wrapper">
              <font-awesome-icon :icon="['fa', 'broadcast-tower']" class="menu-icon" />
            </div>
            <span class="nav-text">Telemetria</span>
            <span class="novo-badge">Novo</span>
            <div class="menu-indicator"></div>
          </router-link>
        </li>

        <!-- Administrativo -->
        <li v-if="$store.getters.user.access.indexOf(23) > -1" :class="{
          'active-menu': $route.path == '/admin/user-list' || $route.path == '/admin/timelogs' ||
            $route.path == '/admin/customer-list' || $route.path == '/admin/logaccess' ||
            $route.path == '/admin/configs' || $route.path == '/admin/reports'
        }">
          <a class="menu-item submenu-trigger" @click="openMenuAdministrativo">
            <div class="menu-icon-wrapper">
              <font-awesome-icon :icon="['fa', 'cogs']" class="menu-icon" />
            </div>
            <span class="nav-text">Administrativo</span>
            <font-awesome-icon :icon="!menuAdministrativoOpened ? ['fa', 'chevron-right'] : ['fa', 'chevron-down']"
              class="submenu-arrow" />
          </a>
          <ul id="menuAdministrativo" class="modern-submenu" :class="{ 'submenu-open': menuAdministrativoOpened }">
            <li v-if="$store.getters.user.access.indexOf(24) > -1">
              <router-link to="/admin/user-list" class="submenu-item">
                <span class="submenu-dot"></span>
                <span>Usuários</span>
              </router-link>
            </li>
            <li v-if="$store.getters.user.access.indexOf(25) > -1">
              <router-link to="/admin/timelogs" class="submenu-item">
                <span class="submenu-dot"></span>
                <span>Tempo de Logs</span>
              </router-link>
            </li>
            <li v-if="$store.getters.user.access.indexOf(26) > -1">
              <router-link to="/admin/logaccess" class="submenu-item">
                <span class="submenu-dot"></span>
                <span>Log de Acesso</span>
              </router-link>
            </li>
            <li v-if="$store.getters.user.access.indexOf(27) > -1">
              <router-link to="/admin/configs" class="submenu-item">
                <span class="submenu-dot"></span>
                <span>Configurações</span>
              </router-link>
            </li>
            <li v-if="$store.getters.user.access.indexOf(28) > -1">
              <router-link to="/admin/reports" class="submenu-item">
                <span class="submenu-dot"></span>
                <span>Relatórios</span>
              </router-link>
            </li>
          </ul>
        </li>

        <!-- Meu Perfil -->
        <li v-else :class="{ 'active-menu': $route.path == '/admin/profile' }">
          <router-link class="menu-item" to="/admin/profile">
            <div class="menu-icon-wrapper">
              <font-awesome-icon :icon="['fa', 'user']" class="menu-icon" />
            </div>
            <span class="nav-text">Meu Perfil</span>
            <div class="menu-indicator"></div>
          </router-link>
        </li>
      </ul>

      <!-- Footer modernizado -->
      <div class="modern-footer">
        <div class="footer-content">
          <div class="company-info">
            <h4>Grupo BAUMINAS</h4>
            <p>© 2023 Todos os direitos reservados</p>
          </div>
          <div class="developer-info">
            <p>Desenvolvido por <a href="https://innovareti.com.br" target="_blank">InnovareTI</a></p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Menu Mobile Moderno -->
  <div class="modern-mobile-overlay" :class="{ 'active': isMobileMenuOpen }" @click="toggleMobileMenu"></div>
  <div class="modern-mobile-menu" :class="{ 'active': isMobileMenuOpen }">
    <div class="mobile-header">
      <div class="mobile-header-content">
        <router-link to="/" class="mobile-brand">
          <img src="../../assets/images/favicon.png" alt="Logo" />
          <span class="brand-text">BAUMINAS</span>
        </router-link>
        <button class="close-btn" @click="toggleMobileMenu">
          <font-awesome-icon :icon="['fa', 'times']" />
        </button>
      </div>
      <div class="mobile-user-info">
        <div class="user-avatar">
          <font-awesome-icon :icon="['fa', 'user-circle']" />
        </div>
        <div class="user-details">
          <span class="user-name">{{ $store.getters.user ? $store.getters.user.name : '' }}</span>
          <span class="company-name">{{ $store.getters.user ? $store.getters.user.customer_name : '' }}</span>
        </div>
      </div>
    </div>

    <div class="mobile-content">
      <nav class="mobile-nav">
        <ul class="mobile-nav-list">
          <li :class="{ 'active': $route.path == '/admin' }">
            <router-link to="/admin" class="nav-link" @click="toggleMobileMenu">
              <div class="nav-icon">
                <font-awesome-icon :icon="['fa', 'home']" />
              </div>
              <span class="nav-label">Página Inicial</span>
            </router-link>
          </li>

          <li v-if="$store.getters.user.access.indexOf(2) > -1"
            :class="{ 'active': $route.path == '/admin/contract-list' }">
            <router-link to="/admin/contract-list" class="nav-link" @click="toggleMobileMenu">
              <div class="nav-icon">
                <font-awesome-icon :icon="['fa', 'file-contract']" />
              </div>
              <span class="nav-label">Contratos</span>
            </router-link>
          </li>

          <li v-if="$store.getters.user.access.indexOf(3) > -1" class="has-submenu">
            <a @click="toggleSubmenu('financeiro')" class="nav-link submenu-toggle">
              <div class="nav-icon">
                <font-awesome-icon :icon="['fa', 'coins']" />
              </div>
              <span class="nav-label">Financeiro</span>
              <div class="submenu-arrow">
                <font-awesome-icon :icon="['fa', submenuFinanceiro ? 'chevron-up' : 'chevron-down']" />
              </div>
            </a>
            <transition name="submenu">
              <ul v-if="submenuFinanceiro" class="mobile-submenu">
                <li v-if="$store.getters.user.access.indexOf(4) > -1">
                  <router-link to="/admin/invoice-list" @click="toggleMobileMenu">
                    <span class="submenu-bullet"></span>
                    <span>Consulta de Títulos</span>
                  </router-link>
                </li>
                <li v-if="$store.getters.user.access.indexOf(5) > -1">
                  <router-link to="/admin/financial-dash" @click="toggleMobileMenu">
                    <span class="submenu-bullet"></span>
                    <span>Dashboard Financeiro</span>
                  </router-link>
                </li>
              </ul>
            </transition>
          </li>

          <li v-if="$store.getters.user.access.indexOf(9) > -1" class="has-submenu">
            <a @click="toggleSubmenu('pedidos')" class="nav-link submenu-toggle">
              <div class="nav-icon">
                <font-awesome-icon :icon="['fa', 'shopping-cart']" />
              </div>
              <span class="nav-label">Pedidos</span>
              <div class="submenu-arrow">
                <font-awesome-icon :icon="['fa', submenuPedidos ? 'chevron-up' : 'chevron-down']" />
              </div>
            </a>
            <transition name="submenu">
              <ul v-if="submenuPedidos" class="mobile-submenu">
                <li v-if="$store.getters.user.access.indexOf(10) > -1">
                  <router-link to="/admin/order-new" @click="toggleMobileMenu">
                    <span class="submenu-bullet"></span>
                    <span>Novo Pedido</span>
                  </router-link>
                </li>
                <li v-if="$store.getters.user.access.indexOf(11) > -1">
                  <router-link to="/admin/order-unbilled-list" @click="toggleMobileMenu">
                    <span class="submenu-bullet"></span>
                    <span>Pedidos a Faturar</span>
                  </router-link>
                </li>
                <li v-if="$store.getters.user.access.indexOf(12) > -1">
                  <router-link to="/admin/order-list" @click="toggleMobileMenu">
                    <span class="submenu-bullet"></span>
                    <span>Pedidos em Rota</span>
                  </router-link>
                </li>
                <li v-if="$store.getters.user.access.indexOf(13) > -1">
                  <router-link to="/admin/order-finished-list" @click="toggleMobileMenu">
                    <span class="submenu-bullet"></span>
                    <span>Pedidos Entregues</span>
                  </router-link>
                </li>
                <li v-if="$store.getters.user.access.indexOf(14) > -1">
                  <router-link to="/admin/order-list-ni" @click="toggleMobileMenu">
                    <span class="submenu-bullet"></span>
                    <span>Pedidos Realizados</span>
                  </router-link>
                </li>
                <li v-if="$store.getters.user.access.indexOf(15) > -1">
                  <router-link to="/admin/order-draft" @click="toggleMobileMenu">
                    <span class="submenu-bullet"></span>
                    <span>Pedidos em Rascunho</span>
                  </router-link>
                </li>
              </ul>
            </transition>
          </li>

          <li v-if="dotEnv.isAmbientaly && $store.getters.user.access.indexOf(19) > -1"
            :class="{ 'active': $route.path == '/admin/packaging-list' }">
            <router-link to="/admin/packaging-list" class="nav-link" @click="toggleMobileMenu">
              <div class="nav-icon">
                <font-awesome-icon :icon="['fa', 'box-open']" />
              </div>
              <span class="nav-label">Embalagens</span>
            </router-link>
          </li>

          <li v-if="$store.getters.user.access.indexOf(20) > -1" class="has-submenu">
            <a @click="toggleSubmenu('documentos')" class="nav-link submenu-toggle">
              <div class="nav-icon">
                <font-awesome-icon :icon="['fa', 'file-alt']" />
              </div>
              <span class="nav-label">Documentos</span>
              <div class="submenu-arrow">
                <font-awesome-icon :icon="['fa', submenuDocumentos ? 'chevron-up' : 'chevron-down']" />
              </div>
            </a>
            <transition name="submenu">
              <ul v-if="submenuDocumentos" class="mobile-submenu">
                <li v-if="$store.getters.user.access.indexOf(21) > -1">
                  <router-link to="/admin/fds-list" @click="toggleMobileMenu">
                    <span class="submenu-bullet"></span>
                    <span>FDS</span>
                  </router-link>
                </li>
                <li v-if="$store.getters.user.access.indexOf(22) > -1">
                  <router-link to="/admin/fde-list" @click="toggleMobileMenu">
                    <span class="submenu-bullet"></span>
                    <span>Ficha de Emergência</span>
                  </router-link>
                </li>
                <li v-if="$store.getters.user.access.indexOf(29) > -1">
                  <router-link to="/admin/winner-docs" @click="toggleMobileMenu">
                    <span class="submenu-bullet"></span>
                    <span>Certidões</span>
                  </router-link>
                </li>
              </ul>
            </transition>
          </li>

          <li v-if="$store.getters.user.access.indexOf(40) > -1"
            :class="{ 'active': $route.path == '/admin/telemetry' }">
            <router-link to="/admin/telemetry" class="nav-link" @click="toggleMobileMenu">
              <div class="nav-icon">
                <font-awesome-icon :icon="['fa', 'broadcast-tower']" />
              </div>
              <span class="nav-label">Telemetria</span>
              <span class="novo-badge-mobile">Novo</span>
            </router-link>
          </li>

          <li v-if="$store.getters.user.access.indexOf(23) > -1" class="has-submenu">
            <a @click="toggleSubmenu('administrativo')" class="nav-link submenu-toggle">
              <div class="nav-icon">
                <font-awesome-icon :icon="['fa', 'cogs']" />
              </div>
              <span class="nav-label">Administrativo</span>
              <div class="submenu-arrow">
                <font-awesome-icon :icon="['fa', submenuAdministrativo ? 'chevron-up' : 'chevron-down']" />
              </div>
            </a>
            <transition name="submenu">
              <ul v-if="submenuAdministrativo" class="mobile-submenu">
                <li v-if="$store.getters.user.access.indexOf(24) > -1">
                  <router-link to="/admin/user-list" @click="toggleMobileMenu">
                    <span class="submenu-bullet"></span>
                    <span>Usuários</span>
                  </router-link>
                </li>
                <li v-if="$store.getters.user.access.indexOf(25) > -1">
                  <router-link to="/admin/timelogs" @click="toggleMobileMenu">
                    <span class="submenu-bullet"></span>
                    <span>Tempo de Logs</span>
                  </router-link>
                </li>
                <li v-if="$store.getters.user.access.indexOf(26) > -1">
                  <router-link to="/admin/logaccess" @click="toggleMobileMenu">
                    <span class="submenu-bullet"></span>
                    <span>Log de Acesso</span>
                  </router-link>
                </li>
                <li v-if="$store.getters.user.access.indexOf(27) > -1">
                  <router-link to="/admin/configs" @click="toggleMobileMenu">
                    <span class="submenu-bullet"></span>
                    <span>Configurações</span>
                  </router-link>
                </li>
                <li v-if="$store.getters.user.access.indexOf(28) > -1">
                  <router-link to="/admin/reports" @click="toggleMobileMenu">
                    <span class="submenu-bullet"></span>
                    <span>Relatórios</span>
                  </router-link>
                </li>
              </ul>
            </transition>
          </li>

          <li class="has-submenu">
            <a @click="toggleSubmenu('trocar-empresa')" class="nav-link submenu-toggle">
              <div class="nav-icon">
                <font-awesome-icon :icon="['fa', 'building']" />
              </div>
              <span class="nav-label">Trocar Empresa</span>
              <div class="submenu-arrow">
                <font-awesome-icon :icon="['fa', submenuTrocarEmpresa ? 'chevron-up' : 'chevron-down']" />
              </div>
            </a>
            <transition name="submenu">
              <ul v-if="submenuTrocarEmpresa" class="mobile-submenu">
                <li v-for="(userCompany, index) in $store.getters.userCompanies" :key="index">
                  <a @click="trocarEmpresa(userCompany); toggleMobileMenu()">
                    <span class="submenu-bullet"></span>
                    <span>{{ userCompany.customer.name }}</span>
                  </a>
                </li>
              </ul>
            </transition>
          </li>
        </ul>
      </nav>
    </div>
  </div>

</template>

<script>
import env from "../../env.js";

export default {
  name: 'Navbar',
  props: {
    isMobileMenuOpen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      menuFinanceiroOpened: false,
      menuCotacaoOpened: false,
      menuDocumentsOpened: false,
      menuPedidosOpened: false,
      menuAdministrativoOpened: false,
      menuDeliveryOpened: false,
      dotEnv: {
        isAmbientaly: false,
      },
      submenuFinanceiro: false,
      submenuPedidos: false,
      submenuDocumentos: false,
      submenuAdministrativo: false,
      submenuTrocarEmpresa: false,
    };
  },
  methods: {
    trocarEmpresa(userCompany) {
      this.$store.dispatch('changeUserCompany', userCompany)
    },
    toggleMobileMenu() {
      this.$emit('toggleMobileMenu');
    },
    openMenu() {
      this.menuCotacaoOpened = false;
      this.menuDocumentsOpened = false;
      this.menuPedidosOpened = false;
      this.menuAdministrativoOpened = false;
      this.menuDeliveryOpened = false;
      $(".mm-collapse").removeClass("mm-show");
      this.menuFinanceiroOpened =
        this.menuFinanceiroOpened == true ? false : true;
      if (this.menuFinanceiroOpened) {
        $("#menuFinanceiro").addClass("mm-show");
      } else {
        $("#menuFinanceiro").removeClass("mm-show");
      }
    },
    openMenuOrder() {
      this.menuFinanceiroOpened = false;
      this.menuCotacaoOpened = false;
      this.menuDocumentsOpened = false;
      this.menuAdministrativoOpened = false;
      this.menuDeliveryOpened = false;
      $(".mm-collapse").removeClass("mm-show");
      this.menuPedidosOpened = this.menuPedidosOpened == true ? false : true;
      if (this.menuPedidosOpened) {
        $("#menuPedidos").addClass("mm-show");
      } else {
        $("#menuPedidos").removeClass("mm-show");
      }
    },
    openMenuDocuments() {
      this.menuFinanceiroOpened = false;
      this.menuCotacaoOpened = false;
      this.menuPedidosOpened = false;
      this.menuAdministrativoOpened = false;
      this.menuDeliveryOpened = false;
      $(".mm-collapse").removeClass("mm-show");
      this.menuDocumentsOpened =
        this.menuDocumentsOpened == true ? false : true;
      if (this.menuDocumentsOpened) {
        $("#menuDocuments").addClass("mm-show");
      } else {
        $("#menuDocuments").removeClass("mm-show");
      }
    },
    openMenuAdministrativo() {
      this.menuFinanceiroOpened = false;
      this.menuCotacaoOpened = false;
      this.menuDocumentsOpened = false;
      this.menuPedidosOpened = false;
      this.menuDeliveryOpened = false;
      $(".mm-collapse").removeClass("mm-show");
      this.menuAdministrativoOpened =
        this.menuAdministrativoOpened == true ? false : true;
      if (this.menuAdministrativoOpened) {
        $("#menuAdministrativo").addClass("mm-show");
      } else {
        $("#menuAdministrativo").removeClass("mm-show");
      }
    },
    toggleSubmenu(menu) {
      switch (menu) {
        case 'financeiro':
          this.submenuFinanceiro = !this.submenuFinanceiro;
          break;
        case 'pedidos':
          this.submenuPedidos = !this.submenuPedidos;
          break;
        case 'documentos':
          this.submenuDocumentos = !this.submenuDocumentos;
          break;
        case 'administrativo':
          this.submenuAdministrativo = !this.submenuAdministrativo;
          break;
        case 'trocar-empresa':
          this.submenuTrocarEmpresa = !this.submenuTrocarEmpresa;
          break;
      }
    },
  },
  created() {
    this.dotEnv.isAmbientaly = env.isAmbientaly;
  }
};
</script>

<style>
/* Variáveis CSS para consistência */
:root {
  --primary-color: #3b82f6;
  --primary-dark: #2563eb;
  --secondary-color: #64748b;
  --accent-color: #10b981;
  --danger-color: #ef4444;
  --warning-color: #f59e0b;
  --success-color: #22c55e;
  --dark-color: #1e293b;
  --light-color: #f8fafc;
  --border-color: #e2e8f0;
  --shadow-sm: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --shadow-md: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --shadow-lg: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --border-radius: 8px;
  --transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

/* Scrollbar customizada */
.modern-scroll {
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
}

.modern-scroll::-webkit-scrollbar {
  width: 6px;
}

.modern-scroll::-webkit-scrollbar-track {
  background: transparent;
}

.modern-scroll::-webkit-scrollbar-thumb {
  background-color: #cbd5e1;
  border-radius: 3px;
  transition: background-color 0.3s ease;
}

.modern-scroll::-webkit-scrollbar-thumb:hover {
  background-color: #94a3b8;
}
</style>
<style scoped>
/* ================================
   SIDEBAR MODERNO
================================= */
.deznav.modern-sidebar {
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
  border-right: 1px solid var(--border-color);
  box-shadow: var(--shadow-lg);
  position: fixed;
  top: 60px;
  left: 0;
  height: calc(100vh - 60px);
  overflow: hidden;
  width: 260px !important;
  min-width: 260px !important;
  max-width: 260px !important;
  z-index: 1000;
}

.modern-sidebar {
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
  border-right: 1px solid var(--border-color);
  box-shadow: var(--shadow-lg);
  position: fixed;
  top: 60px;
  left: 0;
  height: calc(100vh - 60px);
  overflow: hidden;
  width: 260px !important;
  min-width: 260px !important;
  max-width: 260px !important;
  z-index: 1000;
}

.sidebar-gradient {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 200px;
  background: linear-gradient(135deg, rgba(59, 130, 246, 0.05) 0%, rgba(16, 185, 129, 0.05) 100%);
  pointer-events: none;
}

.modern-menu {
  list-style: none;
  padding: 16px 0;
  margin: 0;
  position: relative;
  z-index: 2;
}

.nav-label {
  padding: 0 20px 8px 20px;
  margin: 0 0 12px 0;
  border-bottom: 1px solid var(--border-color);
}

.nav-label-text {
  font-size: 11px;
  font-weight: 700;
  color: var(--secondary-color);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.menu-item {
  display: flex;
  align-items: center;
  padding: 10px 20px;
  margin: 2px 10px;
  border-radius: var(--border-radius);
  color: var(--dark-color);
  text-decoration: none;
  transition: var(--transition);
  position: relative;
  background: transparent;
  border: none;
  width: calc(100% - 20px);
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
}

.menu-item:hover {
  background: linear-gradient(135deg, rgba(59, 130, 246, 0.08) 0%, rgba(16, 185, 129, 0.08) 100%);
  transform: translateX(4px);
  color: var(--primary-color);
}

.active-menu .menu-item {
  background: linear-gradient(135deg, var(--primary-color) 0%, var(--accent-color) 100%);
  color: white;
  box-shadow: var(--shadow-md);
}

.active-menu .menu-item:hover {
  transform: translateX(2px);
  box-shadow: var(--shadow-lg);
}

.menu-icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  margin-right: 12px;
  position: relative;
}

.menu-icon {
  font-size: 16px;
  transition: var(--transition);
}

.nav-text {
  flex: 1;
  font-weight: 500;
}

.menu-indicator {
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: var(--primary-color);
  margin-left: auto;
  opacity: 0;
  transition: var(--transition);
}

.active-menu .menu-indicator {
  opacity: 1;
  background: white;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.7; }
}

/* ================================
   SUBMENUS MODERNOS
================================= */
.submenu-trigger {
  width: 100%;
  border: none;
  background: none;
  font-family: inherit;
}

.submenu-arrow {
  margin-left: auto;
  transition: var(--transition);
  font-size: 12px;
}

.modern-submenu {
  list-style: none;
  padding: 0;
  margin: 0;
  overflow: hidden;
  transition: var(--transition);
  background: rgba(248, 250, 252, 0.8);
  border-radius: 0 0 var(--border-radius) var(--border-radius);
  margin: 0 10px 6px 10px;
}

.modern-submenu:not(.submenu-open) {
  max-height: 0;
  opacity: 0;
}

.submenu-open {
  max-height: 500px;
  opacity: 1;
  padding: 8px 0;
}

.submenu-item {
  display: flex;
  align-items: center;
  padding: 10px 20px 10px 40px;
  color: var(--secondary-color);
  text-decoration: none;
  transition: var(--transition);
  font-size: 13px;
  font-weight: 500;
  border-radius: 6px;
  margin: 2px 8px;
}

.submenu-item:hover {
  background: rgba(59, 130, 246, 0.1);
  color: var(--primary-color);
  transform: translateX(4px);
}

.submenu-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--secondary-color);
  margin-right: 12px;
  transition: var(--transition);
}

.submenu-item:hover .submenu-dot {
  background: var(--primary-color);
  transform: scale(1.2);
}

/* ================================
   BADGE NOVO
================================= */
.novo-badge {
  background: linear-gradient(135deg, var(--danger-color) 0%, #ff6b6b 100%);
  color: white;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 10px;
  font-weight: 700;
  margin-left: auto;
  animation: glow 2s ease-in-out infinite alternate;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

@keyframes glow {
  from { box-shadow: 0 0 5px rgba(239, 68, 68, 0.5); }
  to { box-shadow: 0 0 15px rgba(239, 68, 68, 0.8); }
}

/* ================================
   FOOTER MODERNO
================================= */
.modern-footer {
  padding: 16px;
  border-top: 1px solid var(--border-color);
  background: linear-gradient(135deg, rgba(248, 250, 252, 0.9) 0%, rgba(241, 245, 249, 0.9) 100%);
  margin-top: auto;
}

.footer-content {
  text-align: center;
}

.company-info h4 {
  margin: 0 0 8px 0;
  font-size: 14px;
  font-weight: 700;
  color: var(--dark-color);
  background: linear-gradient(135deg, var(--primary-color) 0%, var(--accent-color) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.company-info p,
.developer-info p {
  margin: 4px 0;
  font-size: 11px;
  color: var(--secondary-color);
}

.developer-info a {
  color: var(--primary-color);
  text-decoration: none;
  font-weight: 600;
  transition: var(--transition);
}

.developer-info a:hover {
  color: var(--accent-color);
}

/* ================================
   MENU MOBILE MODERNO
================================= */
.modern-mobile-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 9998;
  opacity: 0;
  visibility: hidden;
  transition: var(--transition);
  backdrop-filter: blur(5px);
}

.modern-mobile-overlay.active {
  opacity: 1;
  visibility: visible;
}

.modern-mobile-menu {
  position: fixed;
  top: 0;
  right: -100%;
  width: 320px;
  height: 100vh;
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
  z-index: 9999;
  transition: var(--transition);
  box-shadow: var(--shadow-lg);
  display: flex;
  flex-direction: column;
  border-left: 1px solid var(--border-color);
}

.modern-mobile-menu.active {
  right: 0;
}

.mobile-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.mobile-header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}

.mobile-brand {
  display: flex;
  align-items: center;
  gap: 12px;
  text-decoration: none;
  color: white;
}

.mobile-brand img {
  width: 32px;
  height: 32px;
  border-radius: 6px;
}

.brand-text {
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0.5px;
}

.close-btn {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: white;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: var(--transition);
}

.close-btn:hover {
  background: rgba(255, 255, 255, 0.2);
}

.mobile-user-info {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.user-avatar {
  width: 48px;
  height: 48px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}

.user-details {
  flex: 1;
  min-width: 0;
}

.user-name {
  display: block;
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.mobile-content {
  flex: 1;
  overflow-y: auto;
  padding: 20px 0;
}

.mobile-nav-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.mobile-nav-list li {
  margin: 4px 12px;
}

.nav-link {
  display: flex;
  align-items: center;
  padding: 14px 16px;
  color: var(--dark-color);
  text-decoration: none;
  border-radius: var(--border-radius);
  transition: var(--transition);
  font-weight: 500;
  position: relative;
}

.nav-link:hover {
  background: linear-gradient(135deg, rgba(59, 130, 246, 0.08) 0%, rgba(16, 185, 129, 0.08) 100%);
  color: var(--primary-color);
  transform: translateX(4px);
}

.mobile-nav-list li.active .nav-link {
  background: linear-gradient(135deg, var(--primary-color) 0%, var(--accent-color) 100%);
  color: white;
  box-shadow: var(--shadow-md);
}

.nav-icon {
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
}

.nav-label {
  flex: 1;
  font-size: 14px;
}

.submenu-arrow {
  margin-left: auto;
  font-size: 12px;
  transition: var(--transition);
}

.mobile-submenu {
  list-style: none;
  padding: 8px 0;
  margin: 8px 0 0 0;
  background: rgba(248, 250, 252, 0.8);
  border-radius: var(--border-radius);
  border: 1px solid var(--border-color);
}

.mobile-submenu li a {
  display: flex;
  align-items: center;
  padding: 10px 20px;
  color: var(--secondary-color);
  text-decoration: none;
  transition: var(--transition);
  font-size: 13px;
  margin: 2px 8px;
  border-radius: 6px;
}

.mobile-submenu li a:hover {
  background: rgba(59, 130, 246, 0.1);
  color: var(--primary-color);
  transform: translateX(4px);
}

.submenu-bullet {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--secondary-color);
  margin-right: 12px;
  transition: var(--transition);
}

.mobile-submenu li a:hover .submenu-bullet {
  background: var(--primary-color);
  transform: scale(1.2);
}

.novo-badge-mobile {
  background: linear-gradient(135deg, var(--danger-color) 0%, #ff6b6b 100%);
  color: white;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 9px;
  font-weight: 700;
  margin-left: auto;
  animation: glow 2s ease-in-out infinite alternate;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

/* Animações de transição para submenus */
.submenu-enter-active,
.submenu-leave-active {
  transition: all 0.3s ease;
}

.submenu-enter-from,
.submenu-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

/* ================================
   RESPONSIVIDADE
================================= */
@media (max-width: 1024px) {
  .modern-sidebar,
  .deznav.modern-sidebar {
    display: none !important;
  }

  .modern-mobile-overlay.active {
    opacity: 1;
    visibility: visible;
  }

  .modern-mobile-menu.active {
    right: 0;
  }
}

@media (max-width: 768px) {
  .modern-mobile-menu {
    width: 100%;
    right: -100%;
  }
}

@media (max-width: 480px) {
  .mobile-header {
    padding: 16px;
  }

  .mobile-user-info {
    padding: 12px;
  }

  .user-name {
    font-size: 13px;
  }

  .company-name {
    font-size: 11px;
  }
}
</style>